import React, { useState, useEffect, useRef } from "react";
import { Text, View, Animated, Dimensions } from "react-native";
import { withRouter } from "react-router-dom";
import Header from "../../../../../Components/MandG/Header";
import {
  buttonText,
  knowledgeTextPrePage,
} from "../../../../../Utils/static-strings";
import { heightPercentageToDP as hp } from "../../../../../Utils/responsive";
import { styles } from "./Styles/index";
import ContinueButton from "../../../../../Components/ContinueButton";
import clockIcon from "../../../../../assets/images/clock-regular-full.svg";

const backgroundColor = "var(--game-background-color-obj)";
const deviceWidth = Dimensions.get("window").width;

const Index = (props) => {
  const imageOpacity = useRef(new Animated.Value(0)).current;
  const imageSize = Math.min(430, deviceWidth * 0.35);
  const mainAnimation = useState(new Animated.Value(0))[0];
  const GraphicsAnimation = useState(new Animated.Value(-500))[0];
  const TriangleAnimation = useState(new Animated.Value(-100))[0];
  const RectangeAnimation = useState(new Animated.Value(-200))[0];
  const CircleAnimation = useState(new Animated.Value(-300))[0];

  useEffect(() => {
    Animated.parallel([
      Animated.timing(mainAnimation, {
        toValue: 1,
        duration: 1200,
        useNativeDriver: false,
      }),
      Animated.timing(imageOpacity, {
        toValue: 1,
        duration: 800,
        useNativeDriver: false,
      }),
      Animated.timing(TriangleAnimation, {
        toValue:
          deviceWidth < 1350
            ? deviceWidth < 1250
              ? deviceWidth < 1000
                ? deviceWidth < 800
                  ? deviceWidth < 380
                    ? -30
                    : -70
                  : -70
                : -48
              : -48
            : 0,
        duration: 1200,
        useNativeDriver: false,
      }),
      Animated.timing(GraphicsAnimation, {
        toValue:
          deviceWidth < 1350
            ? deviceWidth < 1250
              ? deviceWidth < 1000
                ? deviceWidth < 800
                  ? deviceWidth < 380
                    ? -30
                    : -70
                  : -70
                : -48
              : -48
            : 0,
        duration: 1200,
        useNativeDriver: false,
      }),
      Animated.timing(RectangeAnimation, {
        toValue:
          deviceWidth < 1350
            ? deviceWidth < 1250
              ? deviceWidth < 1000
                ? deviceWidth < 800
                  ? deviceWidth < 380
                    ? -30
                    : -70
                  : -70
                : -48
              : -48
            : 0,
        duration: 1200,
        useNativeDriver: false,
      }),
      Animated.timing(CircleAnimation, {
        toValue:
          deviceWidth < 1350
            ? deviceWidth < 1250
              ? deviceWidth < 1000
                ? deviceWidth < 800
                  ? deviceWidth < 380
                    ? -30
                    : -70
                  : -70
                : -48
              : -48
            : 0,
        duration: 1200,
        useNativeDriver: false,
      }),
    ]).start();
  }, []);

  //deviceWidth < 650 ? 232 : 355

  const opacityInterpolate = mainAnimation.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 1],
  });

  const leftTextAnimationInterpolate = mainAnimation.interpolate({
    inputRange: [0, 1],
    outputRange: ["-50%", "0%"],
  });

  const { setPrePage, moduleObject } = props;

  return (
    <div
      style={{
        height: "100%", // deviceWidth > 600 ? '85vh' : '88vh',
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor,
        position: "absolute",
      }}
    >
      <Header currentRoute={"Understanding"} />
      <Animated.View
        style={[
          styles.body,
          {
            transform: [{ translateX: leftTextAnimationInterpolate }],
            opacity: opacityInterpolate,
          },
        ]}
      >
        <View style={styles.bodyHeader}>
          <Text style={styles.headerText}>{moduleObject.name}</Text>
        </View>
        <View style={styles.bodyTextContainer}>
          <Text style={styles.bodyText}>{knowledgeTextPrePage}</Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            marginBottom: hp("3%"),
            height: 18,
            marginLeft: "7%",
          }}
        >
          <img
            src={clockIcon}
            alt=""
            style={{ width: 18, height: 18, objectFit: "contain" }}
          />
          <Text
            style={{
              fontSize: 14,
              fontFamily: "Infra",
              color: "#2f2f2f",
              paddingLeft: 10,
            }}
          >
            Typically 2-5 minutes
          </Text>
        </View>
        <ContinueButton
          text={buttonText}
          style={{ marginLeft: "7%" }}
          onClick={() => setPrePage(false)}
        />
      </Animated.View>

      <View style={{ height: "25%", width: "100%" }}></View>
      <Animated.Image
        source={require("../../../../../assets/images/mandg/mandg-active-square-obj.png")}
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: imageSize,
          height: imageSize,
          resizeMode: "contain",
          pointerEvents: "none",
          opacity: imageOpacity,
        }}
      />
    </div>
  );
};

export default withRouter(Index);
